import { RootState } from '~/store';

export const getStepperIsMicrositeDataValid = (state: RootState) => state.stepperReducer.isMicrositeDataValid;
export const getStepperData = (state: RootState) => state.stepperReducer;
